import React, { useLayoutEffect } from "react";
import styles from "./AiShipping.module.css";
import { Link } from "react-router-dom";
import { CALENDLY_TALK_TO_US_URL } from "../../../constants";
import {
  HERO_GET_STARTED_ARIA_LABEL,
  HERO_GET_STARTED_LABEL,
  HERO_SUBTEXT,
  HERO_TALK_TO_US_SUBTEXT,
  HERO_TITLE_LINE_1,
  HERO_TITLE_LINE_2,
  HERO_PRODUCT_LINK_ARIA_LABEL,
  HERO_CONNECT_GITHUB_LABEL,
  HERO_CONNECT_GITHUB_ARIA_LABEL,
} from "../../../constants/platformCopy";

const HERO_IMAGE_URL = `${process.env.PUBLIC_URL}/hero-blended.webp`;

const AiShippingSection: React.FC = () => {
  useLayoutEffect(() => {
    document.getElementById("static-hero")?.remove();
  }, []);

  return (
    <div className={styles.aiShippingContainer}>
      <div className={styles.heroFlexContainer}>
        <div className={styles.heroTextContainer}>
          <h1 className={styles.aiShippingTitle}>
            {HERO_TITLE_LINE_1}
            <span className={styles.titleLineBreak}>{HERO_TITLE_LINE_2}</span>
          </h1>

          <p className={styles.aiShippingTitleSub}>{HERO_SUBTEXT}</p>
          <div className={styles.heroButtonWrapper}>
            <div className={styles.heroActionGrid}>
              <Link
                to="/start"
                className={styles.aiShippingContentLeftButton}
                aria-label={HERO_GET_STARTED_ARIA_LABEL}
              >
                {HERO_GET_STARTED_LABEL}
              </Link>
              <a
                href={CALENDLY_TALK_TO_US_URL}
                className={styles.talkToUsButton}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Talk to Us"
              >
                <span className={styles.talkToUsTitle}>Talk to Us</span>
                <span className={styles.talkToUsSubtext}>{HERO_TALK_TO_US_SUBTEXT}</span>
              </a>
              <Link
                to="/product"
                className={styles.learnMoreHeroButton}
                aria-label={HERO_PRODUCT_LINK_ARIA_LABEL}
              >
                Learn More
              </Link>
              <Link
                to="/pull-request-helper"
                className={styles.githubHeroButton}
                aria-label={HERO_CONNECT_GITHUB_ARIA_LABEL}
              >
                {HERO_CONNECT_GITHUB_LABEL}
              </Link>
            </div>
          </div>
        </div>

        <div className={styles.heroMediaContainer}>
          <img
            src={HERO_IMAGE_URL}
            alt="Architectural visualization"
            className={styles.blendedImage}
            fetchPriority="high"
            width={1400}
            height={934}
          />
        </div>
      </div>
    </div>
  );
};

export default AiShippingSection;
